import { combineReducers } from "redux";
import authReducer from "./authReducer";
import commonReducer from "./commonReducer";
import dashboardReducer from "./dashboardReducer";
import superadminReducer from "./superadminReducer";
import adminReducer from "./adminReducer";
import partnerReducer from "./partnerReducer";
import revenueReducer from "./revenueReducer";
import payoutReducer from "./payoutReducer";

const rootReducer = combineReducers({
    authReducer,
    commonReducer,
    dashboardReducer,
    superadminReducer,
    adminReducer,
    partnerReducer,
    revenueReducer,
    payoutReducer
});

export default rootReducer;